module.exports = __webpack_public_path__ + "img/2024-03-08b_3.3a17d672.jpg";